interface IElements {
  //buttonActivate?: HTMLButtonElement | null;
  buttonCreateClone?: HTMLButtonElement | null;
  buttonDelete?: HTMLButtonElement | null;
  buttonStep2?: HTMLButtonElement | null;
  buttonUploadSecondary?: HTMLElement | null;
  chatBox?: HTMLElement | null;
  chatBoxMessages?: HTMLElement | null;
  chatGPTprompt?: HTMLInputElement | null;
  hiddenFileInput?: HTMLElement | null;
  imageInput?: HTMLInputElement | null;
  imagePreviewContainer?: HTMLElement | null;
  imagesLibraryContainer?: HTMLElement | null;
  introVideo?: HTMLElement | null;
  memberName?: HTMLInputElement | null;
  notifications?: HTMLElement | null;
  notificationsText?: HTMLElement | null;
  preloader?: HTMLElement | null;
  previewImage?: HTMLElement | null;

  sendButton?: HTMLElement | null;
  uploadButton?: HTMLInputElement | null;
  uploadButtonMediaLibrary?: HTMLElement | null;
  userInput?: HTMLInputElement | null;
  videoControls?: HTMLElement | null;
  videoControlsPause?: HTMLElement | null;
  videoControlsPlay?: HTMLElement | null;
  videoLibraryContainer?: HTMLElement | null;
  videoThumbnails?: HTMLElement | null;
}

export class ElementsManager {
  private _elements: IElements;

  constructor() {
    this._elements = {
      // buttonActivate: document.querySelector('[cc-element="button-activate"]') as HTMLButtonElement,
      buttonCreateClone: document.querySelector(
        '[cc-element="button-create-clone"]'
      ) as HTMLButtonElement,
      buttonDelete: document.querySelector('[cc-element="button-delete"]') as HTMLButtonElement,
      buttonStep2: document.querySelector('[cc-element="button-step2"]') as HTMLButtonElement,
      buttonUploadSecondary: document.querySelector(
        '[cc-element="button-upload-secondary"]'
      ) as HTMLElement,

      chatBox: document.querySelector('.chat-box') as HTMLElement,
      chatBoxMessages: document.querySelector('.chat-box-messages') as HTMLElement,
      chatGPTprompt: document.getElementById('chat-gpt-prompt') as HTMLInputElement,
      hiddenFileInput: document.getElementById('hiddenFileInput') as HTMLInputElement,
      imageInput: document.getElementById('image-input') as HTMLInputElement,
      imagePreviewContainer: document.getElementById('clone-creator_image-preview') as HTMLElement,
      imagesLibraryContainer: document.getElementById('image-thumbnails') as HTMLElement,
      introVideo: document.querySelector('[cc-element="intro-video"]') as HTMLElement,
      memberName: document.getElementById('member-name') as HTMLInputElement,
      notifications: document.querySelector('[cc-notifications="container"]') as HTMLElement,
      notificationsText: document.querySelector('[cc-notifications="text"]') as HTMLElement,
      preloader: document.querySelector('[cc-element="preloader"]') as HTMLElement,
      previewImage: document.getElementById('preview-image') as HTMLElement,

      sendButton: document.querySelector('[chat-element="send-button"]') as HTMLButtonElement,
      uploadButton: document.getElementById('upload-button') as HTMLInputElement,
      uploadButtonMediaLibrary: document.querySelector(
        '[cc-element="upload-button-media-library"]'
      ) as HTMLElement,
      userInput: document.getElementById('userInput') as HTMLInputElement,
      videoControls: document.querySelector('[cc-element="video-control"]') as HTMLButtonElement,
      videoControlsPause: document.querySelector(
        '[cc-element="video-controls-pause"]'
      ) as HTMLButtonElement,
      videoControlsPlay: document.querySelector(
        '[cc-element="video-controls-play"]'
      ) as HTMLButtonElement,
      videoLibraryContainer: document.getElementById('video-thumbnails') as HTMLElement,
      videoThumbnails: document.getElementById('video-thumbnails') as HTMLElement,
    };
  }

  // Provide a getter to access the elements safely
  get elements(): IElements {
    return this._elements;
  }
}
